import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FaBars,
  FaChevronLeft,
  FaTimes,
  FaUniversity,
  FaUserPlus,
  FaUserShield,
  FaDatabase,
  FaTrash,
  FaKey,
  FaSignOutAlt
} from 'react-icons/fa';
import './CPNavbar.css';

const CPNavbar = ({ onLogout, children }) => {
  const [isOpen,   setIsOpen]   = useState(window.innerWidth > 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsOpen(!mobile);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setIsOpen(o => !o);
  const closeSidebar  = () => setIsOpen(false);

  const handleLogout = () => {
    if (onLogout) onLogout();
    else {
      localStorage.removeItem('cp_token');
      localStorage.removeItem('cp_admin');
      navigate('/cp/login');
    }
  };

  const navItems = [
    { to: '/cp/colleges',   label: 'Add College',    icon: <FaUniversity />  },
    { to: '/cp/admin',      label: 'Add Admin',      icon: <FaUserPlus />    },
    { to: '/cp/superadmin', label: 'Add Super Admin', icon: <FaUserShield /> },
    { to: '/cp/data',       label: 'Alert Logs',     icon: <FaDatabase />   },
    { to: '/cp/recycle-bin', label: 'Recycle Bin',   icon: <FaTrash />      },
  ];

  const bottomNavItems = [
    { to: '/cp/change-password', label: 'Change Password', icon: <FaKey /> },
  ];

  return (
    <div className="navbar-of-control-panel-layout">

      {/* Mobile overlay */}
      {isMobile && isOpen && (
        <div className="navbar-of-control-panel-overlay" onClick={closeSidebar} />
      )}

      {/* Sidebar */}
      <aside className={`navbar-of-control-panel-sidebar ${isOpen ? 'open' : 'closed'} ${isMobile ? 'mobile' : 'desktop'}`}>
        <div className="navbar-of-control-panel-sidebar-inner">

          {/* ── Close / Collapse button at very top ── */}
          <div className="navbar-of-control-panel-sidebar-top">
            <button
              className={`navbar-of-control-panel-sidebar-close-btn ${!isOpen ? 'collapsed' : ''}`}
              onClick={isMobile ? closeSidebar : toggleSidebar}
              title={isMobile ? 'Close Menu' : (isOpen ? 'Close Menu' : 'Open Menu')}
            >
              {isOpen && <span>Close Menu</span>}
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* Nav links */}
          <nav className="navbar-of-control-panel-nav-group">
            {navItems.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => { if (isMobile) closeSidebar(); }}
                className={({ isActive }) =>
                  `navbar-of-control-panel-nav-item${isActive ? ' active' : ''}`
                }
                title={!isOpen && !isMobile ? item.label : ''}
              >
                <div className="navbar-of-control-panel-nav-icon">{item.icon}</div>
                <span className="navbar-of-control-panel-nav-text">{item.label}</span>
              </NavLink>
            ))}
          </nav>

          {/* Bottom — Change Password + Logout */}
          <nav className="navbar-of-control-panel-nav-group bottom-group">
            {bottomNavItems.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => { if (isMobile) closeSidebar(); }}
                className={({ isActive }) =>
                  `navbar-of-control-panel-nav-item${isActive ? ' active' : ''}`
                }
                title={!isOpen && !isMobile ? item.label : ''}
              >
                <div className="navbar-of-control-panel-nav-icon">{item.icon}</div>
                <span className="navbar-of-control-panel-nav-text">{item.label}</span>
              </NavLink>
            ))}
            <div
              className="navbar-of-control-panel-nav-item logout"
              onClick={handleLogout}
              title={!isOpen && !isMobile ? 'Logout' : ''}
            >
              <div className="navbar-of-control-panel-nav-icon"><FaSignOutAlt /></div>
              <span className="navbar-of-control-panel-nav-text">Logout</span>
            </div>
          </nav>

        </div>
      </aside>

      {/* Main */}
      <main className={`navbar-of-control-panel-main ${isOpen && !isMobile ? 'shifted' : 'collapsed'} ${isMobile ? 'mobile-main' : ''}`}>

        {/* Topbar */}
        <header className="navbar-of-control-panel-topbar">
          <div className="navbar-of-control-panel-topbar-left">
            <button className="navbar-of-control-panel-burger-btn" onClick={toggleSidebar}>
              {isOpen && !isMobile ? <FaChevronLeft /> : <FaBars />}
            </button>
            <h1 className="navbar-of-control-panel-title">Control Panel</h1>
          </div>
        </header>

        {/* Page content */}
        <div className="navbar-of-control-panel-content">
          {children}
        </div>

      </main>
    </div>
  );
};

export default CPNavbar;